import {
  billingCycleDependBasePlanTypeList,
  dependMeetingPlanTypeList,
  licenseDependBasePlanTypeList,
  PlanModelInfo,
  planTypes,
} from '@/common/constants';
import { planUnitMap } from '@/common/product-unit';
import { defaultMapper } from "@/common/service/default-mapper"

const LargeMeetingKey = [
    'large500',
    'large1000',
]

export default (planMapJSON) => {
    if (window.newBillingConfig?.enableLargeMeeting3k5k || window.$context.is.persistCart) {
      LargeMeetingKey.push('large3000', 'large5000');
    }
    return LargeMeetingKey.reduce((pre, key) => {
        return [
            ...defaultMapper(planMapJSON[key], planTypes.LARGE_MEETING).map(item => ({
                ...item,
                capacity: planMapJSON[key].participants,
                participants: planMapJSON[key].participants,
                capacityUnit: planUnitMap.participant,
                typeNameKey: 'billing.large_meeting.title',
                planNameKey: 'billing.large_meeting.title',
                dependBasePlanTypeList: dependMeetingPlanTypeList,
                billingCycleDependBasePlanTypeList,
                licenseDependBasePlanTypeList,
                unit: planUnitMap.license,
                planModel: PlanModelInfo.license
            })),
            ...pre,
        ]
    }, []);
}
